import { render, staticRenderFns } from "./CalibrationTwo.vue?vue&type=template&id=36cc5542&scoped=true"
import script from "./CalibrationTwo.vue?vue&type=script&lang=js"
export * from "./CalibrationTwo.vue?vue&type=script&lang=js"
import style0 from "./CalibrationTwo.vue?vue&type=style&index=0&id=36cc5542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc5542",
  null
  
)

export default component.exports